import z from 'zod';


export function vendorAcceptanceSchema({nonLowBidVendorSelected}){
  return z.object({
    makeColor: z
      .string()
      .refine((val) => val !== '-1' && !!val, 'Please select a color'),
    nonLowPriceJustification: nonLowBidVendorSelected ? z.string().refine(val => !!val , 'Please enter justification') : z.string().optional().nullable()
  })
}